import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Stylesheets
import "./LoadingSpinner.scss";

const LoadingSpinner = ({ classname, color }) => {
  const className = classNames(
    "loading_spinner",
    `loading_spinner_${color}`,
    classname
  );

  return <div data-testid="loading_spinner" className={className} />;
};

LoadingSpinner.propTypes = {
  classname: PropTypes.any,
  color: PropTypes.oneOf(["blue", "navy"]),
};

LoadingSpinner.defaultProps = {
  color: "navy",
};

export default LoadingSpinner;
